<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'LogoutComponent',
  data: () => ({
  }),
  computed: {
    ...mapGetters(['username'])
  },
  created() {
    this.logoutUser()
      .catch(error => {
        console.error('Logout failed: ', error);
      });
    this.$router.replace({ name: 'homepage' }).catch(() => {
    });
  },
  methods: {
    ...mapActions(['logoutUser'])
  }
};
</script>
<template>
  <v-container>
    <v-row class="text-center">
      <v-col>
        <h1 class="primary--text">
          {{ $t('page.logout.view.logout.text') }}
        </h1>
      </v-col>
    </v-row>
  </v-container>
</template>
